export const environment = {
  production: false,
  stage: 'test',
  odoo: {
    DATABASE: 'prod'
  },
  USER_ODOO_GROUP: 'SalesPro User',
  MANAGER_ODOO_GROUP: 'SalesPro Manager',
  ADMIN_ODOO_GROUP: 'SalesPro Admin',
  TRIMMED_LEAD_ID: 4,
  SELF_GEN_LEAD_ID: 28,
  TEMPLATE: {
    '2020 HP Alarm Contract (fortiva)': '70c24451-4f20-4b5b-9ef1-ded8b27c23e6',
    '2020 HP Alarm Contract (Smartpay)': '26d724de-97a8-4e2a-9623-5f3a62a9a45c',
    '2018 HP Alarm Contract (app)': '1cb4e3f0-8291-4a97-b2d1-d90ef49fb28a',
    '2021 HP Alarm Contract (show room)':'68bbc4b7-5224-441a-9b3d-4ec8bad4824a',
    '2021 HP Alarm Contract (3g Renewal)':'59454fc3-e758-428b-975c-5bf650fabe3a',
    '2025 HP Alarm Contract (authorized partner security)':'fe2db985-849b-437b-851e-dd523c4e0a44',    
  },
   SHOWROOM_ODOO_GROUP:'SalesPro - Pre-Select Sales',
   PRE_SELECT_SALES_GROUP:139,
   RENEWAL_ODOO_USER_GROUP_NAME:'SalesPro - 3G upgrades',
   RENEWAL_GROUP : 155,
   RENEWAL_GROUP_1: 154,
   RENEWAL_LIVE_1: 153,
   PRESELECT_RENEWAL_REMOTE_GROUP:['SalesPro Admin','SalesPro - Pre-Select Sales','SalesPro - 3G upgrades'],
   PHONE_SALES_ODOO_USER_GROUP_NAME:'SalesPro - Phone Sales',
   GOOGLE_BUILDER_CLOUD_BUCKET_URL:'https://storage.googleapis.com/builders-docs/',
   NEW_SELFGEN_FLOW:true,
   REMOVE_REP_SIGN: false,
   ENABLE_FULL_PAYMENT_AFTER_FINANCE_APPROVED: false,
   MERGE_CONTRACT_AND_SUMMARY : true,
   ENABLE_PREVIOUS_ADDRESS: true,
   ENABLE_LEND_FOUNDRY: true,
   SYNC_ASSOCIATION:false,
   HAS_LENDFOUNDRY:'SalesPro - Smart Home Pay (Lendfoundry)',
   SHOW_LF_REMOTE:true,
   API_URL: 'https://spback-test-green-fpsfl7iifq-uc.a.run.app/',
   HAS_CREDIT_CHECK: {
      'Trimmed': true,
      'Renewal': true,
      'Show Room': false,
      'Phone Sales': true,
      'Self Gen': true
    },
    ONIT_HOME_ODOO_GROUP:'SalesPro - OnIt Home',
    ONIT_HOME_ODOO_GROUP_ID:'218',
    ONIT_HOME_EXTERNAL_ODOO_GROUP:'SalesPro - OnIt External User',
    SHOW_GOOGLE_LOGIN:true,
    PROCESSING_FEE:3,
    SALESPRO_ADMIN:'salespro.admin@homeprotech.com',
    EXCLUDE_IO_PACKAGES:['SP505'],
    CREDIT_SCORE_PROVIDER:'isoftpull',
    ISOFTPULL_DISAGREE_PROCEED:true ,
    NOTIFIER_TEXT :'',
    API_VERSION : '2026.10.06',
    DEFAULT_CREDIT_SCORE: '640',
    RUN_NEW_CREDIT_POLICY: true,
    FINANCE_PROVIDER: 'svcfin',
    HAS_PRESCREENING: false,
    PRESCREEN_PROVIDER: 'HART',
    HART_ACCOUNT: 'HOMEPRO',
    HART_PASSWORD: 'P8Ie.P*I5yUYH5$v)f07',
    HAS_EQUIPMENT_TYPE : false,
    DEFAULT_SHP_CREDIT_PRODUCT: '01jabc6rsc3jcjv4334mqkw2re',
    MINIMUM_FINANCE_AMOUNT: 100,
    AUTHORIZE_NET_NAME :'94b4bHuHRD',
    AUTHORIZE_NET_TRANSACTION_KEY :'3N26925J3hyfypNY',
    AUTHORIZE_NET_IFRAME_COMMUNICATOR_URL : 'https://salespro.homeprotech.com/auth/authorize/iframecommunicator',
    PAYMENT_GATEWAY : 'authz',
    AUTHORIZE_NET_PAYMENT_URL:'https://accept.authorize.net/payment/payment',
    BW_DELETE_IN_DAYS:30,
    SIGN_MODE: 'ODOO'
};
